import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, LazyImage } from "../../components/Styled/Elements";
import { LogoAr, LogoEn } from "../../components/Styled/AllImages";
import {
  WorkshopParticipantWrapper,
  FormWrapper,
  FormTitle,
  FormGroup,
  Label,
  Input,
  SubmitButton,
} from "./Styled";
import LangChangeButton from "../../Languages/LangChangeButton";
import { Container, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import PhoneInputField from "../../components/Styled/inputFields/PhoneInput";
import { useForm } from "react-hook-form";

const WorkshopParticipant = () => {
  const { t, i18n: { language } } = useTranslation();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
    },
  });

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const res = await axios.post(
        `${API_URL}/workshop-videos/participant`,
        data
      );

      if (res.data?.code === 200) {
        localStorage.setItem(
          "participant_data",
          JSON.stringify(res.data.data)
        );
      }

      toast.success(t("participant_submission_successful"));
      navigate("/workshop");
    } catch (error) {
      toast.error(t("participant_submission_failed"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("participant_data")) {
      navigate("/workshop");
    }
  }, [navigate]);

  return (
    <WorkshopParticipantWrapper>
      {/* Header */}
      <Box className="d-flex align-items-center justify-content-between participant_header">
        <Box className="logo-container d-flex align-items-center">
          <Link to="/">
            <LazyImage style={{ width: "179px", height: "auto" }} src={language === "en" ? LogoEn : LogoAr} />
          </Link>
        </Box>

        <Container className="d-flex justify-content-end">
          <LangChangeButton />
        </Container>
      </Box>

      {/* Form */}
      <FormWrapper>
        <FormTitle>{t("workshop_registration")}</FormTitle>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Name */}
          <FormGroup>
            <Label>{t("name")}</Label>
            <Input
              type="text"
              {...register("name", { required: t("name_required") })}
            />
          </FormGroup>

          {/* Email */}
          <FormGroup>
            <Label>{t("email")}</Label>
            <Input
              type="email"
              {...register("email", {
                required: t("email_required"),
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: t("email_invalid"),
                },
              })}
            />
          </FormGroup>

          {/* Phone (react-hook-form controlled) */}
          <FormGroup>
            <PhoneInputField
              name="phone"
              label="whatsapp_number"
              control={control}
              staric
              validationRules={{ required: true }}
              className="mb-3 combined flex-wrap p-0"
            />
          </FormGroup>

          {/* Submit */}
          <SubmitButton type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner size="sm" />
                <span className="ms-2">{t("start_workshop")}</span>
              </>
            ) : (
              t("start_workshop")
            )}
          </SubmitButton>
        </form>
      </FormWrapper>
    </WorkshopParticipantWrapper>
  );
};

export default WorkshopParticipant;
